import { FaceDetection } from '@mediapipe/face_detection/face_detection';
import { Results } from '@mediapipe/face_detection';


let callback: Function;
let currFrame: HTMLVideoElement | HTMLImageElement | HTMLCanvasElement;

const faceDetection = new FaceDetection({
	locateFile: (file) => {
		console.log("looking for file", file)
		return `/js/face_detection/${file}`;	
	}
});

export function setupFindFace(cb: Function) {
	faceDetection.setOptions({
		model: 'short',
		minDetectionConfidence: 0.5
	});
	faceDetection.onResults(onResults);
	callback = cb;
	let canvas = document.createElement('canvas');
	faceDetection.send({ image: canvas });
}

export function findFace(frame: HTMLVideoElement | HTMLImageElement | HTMLCanvasElement, cb: Function) {
	callback = cb;
	currFrame = frame;
	faceDetection.send({ image: frame });
}

function onResults(results: Results) {
	if (results && results.detections && results.detections.length > 0) {
		if (callback) callback(results.detections[0]);
	} else{
		if (callback) callback(null);
	}

}